import en from './TranslationsEN.json';
import jp from './TranslationsJP.json';
import de from './TranslationsDE.json';

// jsonを結合する
const data = {
  en: en,
  jp: jp,
  de: de,
};

export {data};
